import React from 'react';

import { TableCellDescriptions } from '../../components/TableCellDescriptions';
import { PinCodeTableFragment, PinCodeTableFragmentDoc } from '../../graphql/hasura/generated';
import { createdAtColumn, updatedAtAndByColumn } from '../common/columns';
import { getDescriptionsFromColumns } from '../helpers/getDescriptionsFromColumns';
import type { IModelTableExpandable } from '../typings';

import * as actions from './actions';
import * as columns from './columns';
import model from './model';

model.actions.setDefaultActions([actions.sendAction, actions.regenerateAction]);

const description = () => {
  return (
    <>
      These PIN codes are used to gain access into the property only and will not work on the residential unit.
      Unit PIN codes (if applicable) are created by the resident.
    </>
  );
};

export const expandable: IModelTableExpandable<PinCodeTableFragment> = {
  rowExpandable: ({ createdAt, updatedAt }) => updatedAt !== createdAt,
  expandedRowRender: (row) => {
    const descriptions = getDescriptionsFromColumns(row, [updatedAtAndByColumn]);

    return <TableCellDescriptions descriptions={descriptions} />;
  },
};

const commonTableConfig = {
  description,
  expandable,
  fragment: PinCodeTableFragmentDoc,
};

export const PinCodesMainTable = model.createTable<PinCodeTableFragment>({
  ...commonTableConfig,
  columns: [
    columns.propertyColumn,
    columns.assignedToColumn,
    columns.codeColumn,
    columns.createdByColumn,
    createdAtColumn,
  ],
});

export const PinCodesByPropertyTable = model.createTable<PinCodeTableFragment, string>({
  ...commonTableConfig,
  fixedQueryFilters: (propertyId) => ({
    propertyId: { _eq: propertyId },
  }),
  columns: [
    columns.assignedToColumn,
    columns.codeColumn,
    columns.createdByColumn,
    createdAtColumn,
  ],
});

export const PinCodesByAssignedToUserTable = model.createTable<PinCodeTableFragment, string>({
  ...commonTableConfig,
  fixedQueryFilters: (userId) => ({
    assignedToUserId: { _eq: userId },
  }),
  columns: [
    columns.propertyColumn,
    columns.codeColumn,
    columns.createdByColumn,
    createdAtColumn,
  ],
  useSubscription: true,
});
